export function getActivityDuration(durationInMinutes: number) {
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;

    return `(${hours > 0 ? hours + 'h' : ''}${
        minutes > 0 ? minutes + 'min' : ''
    })`;
}
